<script>
import button from "@/mixins/toolBar/button";

export default {
  name: "HideAllButton",
  mixins: [button],
  data() {
    return {
      name: "Hide All",
      icon: ""
    };
  },
  methods: {
    execute() {
      this.$parent.hideAll();
    }
  }
};
</script>
